<template>
    <div v-if="field">
        <b-input-group>
            <b-input-group-prepend v-if="$attrs.prefix">
                <b-input-group-text> {{ $attrs.prefix }} </b-input-group-text>
            </b-input-group-prepend>
            <b-form-input 
            type="text" 
            :id="field.key" 
            :placeholder="field.constraints.placeholder"
            v-model="content"
            autocomplete="off"
            v-bind="$attrs"
            ></b-form-input>
            <b-input-group-prepend v-if="$attrs.sufix">
                <b-input-group-text> {{ $attrs.sufix }}</b-input-group-text>
            </b-input-group-prepend>

            <b-form-invalid-feedback :id="field.key" style="display:block" v-if="allErrors !== undefined && allErrors.length > 0">
                {{ translateExtendedError(allErrors[0]) || null }}
            </b-form-invalid-feedback>

            <b-form-invalid-feedback :id="field.key" style="display:block" v-else>
                {{ errors[0] || null }}
            </b-form-invalid-feedback>

         </b-input-group>
    </div>
</template>

<script>
export default {
    name: "IdentityField_Text",
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Number | Object,
            default: null
        },
        extendErrors: {
            type: Array
        },
        translator: {
            type: Function
        }
    },
    data: function() {
        return {
            errors: [],
            errorTrans: {
                email_already_exists: "Email already exists",
                unique: "This field must be unique",
                invalid: "Invalid value"
            }
        }
    },
    computed: {
        content: {
            get() {
                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },

        allErrors: {
            get() {
                return this.extendErrors
            },

            set(val) {
                this.errors = val
            }   
        }
    },
    watch: {
        content: function(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            val = val || ""
            this.errors = []
            this.allErrors = []

            if (!val && this.constraints.required) {
                this.errors.push(this.translator("identityField.requiredField"))
                return
            }
            
            if (this.constraints["length"]) {
                if (this.constraints.length.max !== null && this.constraints.length.max > 0) {
                    if (val.length > this.constraints.length.max && val.length > 0) {
                        this.errors.push(
                            this.translator("identityField.cantBeMoreThenChars", {
                                max: this.constraints.length.max
                            })
                        )
                    }
                }
                
                if (this.constraints.length.min !== null) {
                    if (val.length < this.constraints.length.min && val.length > 0) {
                        this.errors.push(
                            this.translator("identityField.cantBeLessThenChars", {
                                min: this.constraints.length.min
                            })
                        )
                    }
                }
            }

            if (val.length > 0) {
                if (this.constraints.not_allowed_words !== undefined) {
                    let notAllowedWords = this.constraints.not_allowed_words.split(",")
                    notAllowedWords.forEach(word => {
                        word = word.trim()

                        if (word != "") {
                            if (val.indexOf(word) !== -1) {
                                if (word.length < 2) {
                                    this.errors.push(
                                        this.translator("identityField.symbolNotAllowed", {
                                            symbol: word
                                        })
                                    )
                                } else {
                                    this.errors.push(
                                        this.translator("identityField.wordNotAllowed", {
                                            word: word
                                        })
                                    )
                                }
                            }  
                        }              
                    })
                }

                if (this.constraints.regex !== undefined || this.constraints.regex !== "") {
                    let re = new RegExp(this.constraints.regex)
                    if (! re.test(val)) {
                        this.errors.push(this.translator("identityFields.invalidInput"))
                    }
                }
            }
                
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0 || this.extendErrors.length})
        },

        translateExtendedError(err) {
            return this.errorTrans[err] || err
        }
    },

    mounted() {
        this.check(this.content)
    }
}
</script>